import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalConstants } from '../Constants/global.constants';
import {
  ApiResponse,
  CreateFloorRoomRequest,
  FloorRoom,
  UpdateFloorRoomRequest
} from '../interface/floor-room';

@Injectable({
  providedIn: 'root'
})
export class FloorRoomService {
  private readonly baseUrl = GlobalConstants.API_URL + 'FloorRoom/';

  constructor(private http: HttpClient) { }

  getByFloor(floorId: string): Observable<ApiResponse<FloorRoom[]>> {
    const params = new HttpParams().set('floorId', floorId);
    return this.http.get<ApiResponse<FloorRoom[]>>(this.baseUrl + 'GetByFloor', { params });
  }

  create(request: CreateFloorRoomRequest): Observable<ApiResponse<FloorRoom>> {
    return this.http.post<ApiResponse<FloorRoom>>(this.baseUrl + 'Create', request);
  }

  update(id: string, request: UpdateFloorRoomRequest): Observable<ApiResponse<FloorRoom>> {
    const params = new HttpParams().set('id', id);
    return this.http.put<ApiResponse<FloorRoom>>(this.baseUrl + 'Update', request, { params });
  }

  delete(id: string): Observable<ApiResponse<null>> {
    const params = new HttpParams().set('id', id);
    return this.http.delete<ApiResponse<null>>(this.baseUrl + 'Delete', { params });
  }
}
